/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as IndexImport } from './routes/index'
import { Route as StationsIndexImport } from './routes/stations/index'
import { Route as StalledIndexImport } from './routes/stalled/index'
import { Route as ReturnsIndexImport } from './routes/returns/index'
import { Route as OrganizationsIndexImport } from './routes/organizations/index'
import { Route as OrdersIndexImport } from './routes/orders/index'
import { Route as InstallationsIndexImport } from './routes/installations/index'
import { Route as InstallationProfilesIndexImport } from './routes/installation-profiles/index'
import { Route as IndexCapturesIndexImport } from './routes/index-captures/index'
import { Route as ContactsIndexImport } from './routes/contacts/index'
import { Route as CompatibilityReviewIndexImport } from './routes/compatibility-review/index'
import { Route as StationsStationIdImport } from './routes/stations/$stationId'
import { Route as OrdersNewImport } from './routes/orders/new'
import { Route as InstallationsNewImport } from './routes/installations/new'
import { Route as InstallationsInstallationIdImport } from './routes/installations/$installationId'

// Create/Update Routes

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const StationsIndexRoute = StationsIndexImport.update({
  id: '/stations/',
  path: '/stations/',
  getParentRoute: () => rootRoute,
} as any)

const StalledIndexRoute = StalledIndexImport.update({
  id: '/stalled/',
  path: '/stalled/',
  getParentRoute: () => rootRoute,
} as any)

const ReturnsIndexRoute = ReturnsIndexImport.update({
  id: '/returns/',
  path: '/returns/',
  getParentRoute: () => rootRoute,
} as any)

const OrganizationsIndexRoute = OrganizationsIndexImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => rootRoute,
} as any)

const OrdersIndexRoute = OrdersIndexImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => rootRoute,
} as any)

const InstallationsIndexRoute = InstallationsIndexImport.update({
  id: '/installations/',
  path: '/installations/',
  getParentRoute: () => rootRoute,
} as any)

const InstallationProfilesIndexRoute = InstallationProfilesIndexImport.update({
  id: '/installation-profiles/',
  path: '/installation-profiles/',
  getParentRoute: () => rootRoute,
} as any)

const IndexCapturesIndexRoute = IndexCapturesIndexImport.update({
  id: '/index-captures/',
  path: '/index-captures/',
  getParentRoute: () => rootRoute,
} as any)

const ContactsIndexRoute = ContactsIndexImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => rootRoute,
} as any)

const CompatibilityReviewIndexRoute = CompatibilityReviewIndexImport.update({
  id: '/compatibility-review/',
  path: '/compatibility-review/',
  getParentRoute: () => rootRoute,
} as any)

const StationsStationIdRoute = StationsStationIdImport.update({
  id: '/stations/$stationId',
  path: '/stations/$stationId',
  getParentRoute: () => rootRoute,
} as any)

const OrdersNewRoute = OrdersNewImport.update({
  id: '/orders/new',
  path: '/orders/new',
  getParentRoute: () => rootRoute,
} as any)

const InstallationsNewRoute = InstallationsNewImport.update({
  id: '/installations/new',
  path: '/installations/new',
  getParentRoute: () => rootRoute,
} as any)

const InstallationsInstallationIdRoute =
  InstallationsInstallationIdImport.update({
    id: '/installations/$installationId',
    path: '/installations/$installationId',
    getParentRoute: () => rootRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/installations/$installationId': {
      id: '/installations/$installationId'
      path: '/installations/$installationId'
      fullPath: '/installations/$installationId'
      preLoaderRoute: typeof InstallationsInstallationIdImport
      parentRoute: typeof rootRoute
    }
    '/installations/new': {
      id: '/installations/new'
      path: '/installations/new'
      fullPath: '/installations/new'
      preLoaderRoute: typeof InstallationsNewImport
      parentRoute: typeof rootRoute
    }
    '/orders/new': {
      id: '/orders/new'
      path: '/orders/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof OrdersNewImport
      parentRoute: typeof rootRoute
    }
    '/stations/$stationId': {
      id: '/stations/$stationId'
      path: '/stations/$stationId'
      fullPath: '/stations/$stationId'
      preLoaderRoute: typeof StationsStationIdImport
      parentRoute: typeof rootRoute
    }
    '/compatibility-review/': {
      id: '/compatibility-review/'
      path: '/compatibility-review'
      fullPath: '/compatibility-review'
      preLoaderRoute: typeof CompatibilityReviewIndexImport
      parentRoute: typeof rootRoute
    }
    '/contacts/': {
      id: '/contacts/'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof ContactsIndexImport
      parentRoute: typeof rootRoute
    }
    '/index-captures/': {
      id: '/index-captures/'
      path: '/index-captures'
      fullPath: '/index-captures'
      preLoaderRoute: typeof IndexCapturesIndexImport
      parentRoute: typeof rootRoute
    }
    '/installation-profiles/': {
      id: '/installation-profiles/'
      path: '/installation-profiles'
      fullPath: '/installation-profiles'
      preLoaderRoute: typeof InstallationProfilesIndexImport
      parentRoute: typeof rootRoute
    }
    '/installations/': {
      id: '/installations/'
      path: '/installations'
      fullPath: '/installations'
      preLoaderRoute: typeof InstallationsIndexImport
      parentRoute: typeof rootRoute
    }
    '/orders/': {
      id: '/orders/'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersIndexImport
      parentRoute: typeof rootRoute
    }
    '/organizations/': {
      id: '/organizations/'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof OrganizationsIndexImport
      parentRoute: typeof rootRoute
    }
    '/returns/': {
      id: '/returns/'
      path: '/returns'
      fullPath: '/returns'
      preLoaderRoute: typeof ReturnsIndexImport
      parentRoute: typeof rootRoute
    }
    '/stalled/': {
      id: '/stalled/'
      path: '/stalled'
      fullPath: '/stalled'
      preLoaderRoute: typeof StalledIndexImport
      parentRoute: typeof rootRoute
    }
    '/stations/': {
      id: '/stations/'
      path: '/stations'
      fullPath: '/stations'
      preLoaderRoute: typeof StationsIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/installations/$installationId': typeof InstallationsInstallationIdRoute
  '/installations/new': typeof InstallationsNewRoute
  '/orders/new': typeof OrdersNewRoute
  '/stations/$stationId': typeof StationsStationIdRoute
  '/compatibility-review': typeof CompatibilityReviewIndexRoute
  '/contacts': typeof ContactsIndexRoute
  '/index-captures': typeof IndexCapturesIndexRoute
  '/installation-profiles': typeof InstallationProfilesIndexRoute
  '/installations': typeof InstallationsIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/organizations': typeof OrganizationsIndexRoute
  '/returns': typeof ReturnsIndexRoute
  '/stalled': typeof StalledIndexRoute
  '/stations': typeof StationsIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/installations/$installationId': typeof InstallationsInstallationIdRoute
  '/installations/new': typeof InstallationsNewRoute
  '/orders/new': typeof OrdersNewRoute
  '/stations/$stationId': typeof StationsStationIdRoute
  '/compatibility-review': typeof CompatibilityReviewIndexRoute
  '/contacts': typeof ContactsIndexRoute
  '/index-captures': typeof IndexCapturesIndexRoute
  '/installation-profiles': typeof InstallationProfilesIndexRoute
  '/installations': typeof InstallationsIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/organizations': typeof OrganizationsIndexRoute
  '/returns': typeof ReturnsIndexRoute
  '/stalled': typeof StalledIndexRoute
  '/stations': typeof StationsIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/installations/$installationId': typeof InstallationsInstallationIdRoute
  '/installations/new': typeof InstallationsNewRoute
  '/orders/new': typeof OrdersNewRoute
  '/stations/$stationId': typeof StationsStationIdRoute
  '/compatibility-review/': typeof CompatibilityReviewIndexRoute
  '/contacts/': typeof ContactsIndexRoute
  '/index-captures/': typeof IndexCapturesIndexRoute
  '/installation-profiles/': typeof InstallationProfilesIndexRoute
  '/installations/': typeof InstallationsIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/returns/': typeof ReturnsIndexRoute
  '/stalled/': typeof StalledIndexRoute
  '/stations/': typeof StationsIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/installations/$installationId'
    | '/installations/new'
    | '/orders/new'
    | '/stations/$stationId'
    | '/compatibility-review'
    | '/contacts'
    | '/index-captures'
    | '/installation-profiles'
    | '/installations'
    | '/orders'
    | '/organizations'
    | '/returns'
    | '/stalled'
    | '/stations'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/installations/$installationId'
    | '/installations/new'
    | '/orders/new'
    | '/stations/$stationId'
    | '/compatibility-review'
    | '/contacts'
    | '/index-captures'
    | '/installation-profiles'
    | '/installations'
    | '/orders'
    | '/organizations'
    | '/returns'
    | '/stalled'
    | '/stations'
  id:
    | '__root__'
    | '/'
    | '/installations/$installationId'
    | '/installations/new'
    | '/orders/new'
    | '/stations/$stationId'
    | '/compatibility-review/'
    | '/contacts/'
    | '/index-captures/'
    | '/installation-profiles/'
    | '/installations/'
    | '/orders/'
    | '/organizations/'
    | '/returns/'
    | '/stalled/'
    | '/stations/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  InstallationsInstallationIdRoute: typeof InstallationsInstallationIdRoute
  InstallationsNewRoute: typeof InstallationsNewRoute
  OrdersNewRoute: typeof OrdersNewRoute
  StationsStationIdRoute: typeof StationsStationIdRoute
  CompatibilityReviewIndexRoute: typeof CompatibilityReviewIndexRoute
  ContactsIndexRoute: typeof ContactsIndexRoute
  IndexCapturesIndexRoute: typeof IndexCapturesIndexRoute
  InstallationProfilesIndexRoute: typeof InstallationProfilesIndexRoute
  InstallationsIndexRoute: typeof InstallationsIndexRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
  OrganizationsIndexRoute: typeof OrganizationsIndexRoute
  ReturnsIndexRoute: typeof ReturnsIndexRoute
  StalledIndexRoute: typeof StalledIndexRoute
  StationsIndexRoute: typeof StationsIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  InstallationsInstallationIdRoute: InstallationsInstallationIdRoute,
  InstallationsNewRoute: InstallationsNewRoute,
  OrdersNewRoute: OrdersNewRoute,
  StationsStationIdRoute: StationsStationIdRoute,
  CompatibilityReviewIndexRoute: CompatibilityReviewIndexRoute,
  ContactsIndexRoute: ContactsIndexRoute,
  IndexCapturesIndexRoute: IndexCapturesIndexRoute,
  InstallationProfilesIndexRoute: InstallationProfilesIndexRoute,
  InstallationsIndexRoute: InstallationsIndexRoute,
  OrdersIndexRoute: OrdersIndexRoute,
  OrganizationsIndexRoute: OrganizationsIndexRoute,
  ReturnsIndexRoute: ReturnsIndexRoute,
  StalledIndexRoute: StalledIndexRoute,
  StationsIndexRoute: StationsIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/installations/$installationId",
        "/installations/new",
        "/orders/new",
        "/stations/$stationId",
        "/compatibility-review/",
        "/contacts/",
        "/index-captures/",
        "/installation-profiles/",
        "/installations/",
        "/orders/",
        "/organizations/",
        "/returns/",
        "/stalled/",
        "/stations/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/installations/$installationId": {
      "filePath": "installations/$installationId.tsx"
    },
    "/installations/new": {
      "filePath": "installations/new.tsx"
    },
    "/orders/new": {
      "filePath": "orders/new.tsx"
    },
    "/stations/$stationId": {
      "filePath": "stations/$stationId.tsx"
    },
    "/compatibility-review/": {
      "filePath": "compatibility-review/index.tsx"
    },
    "/contacts/": {
      "filePath": "contacts/index.tsx"
    },
    "/index-captures/": {
      "filePath": "index-captures/index.tsx"
    },
    "/installation-profiles/": {
      "filePath": "installation-profiles/index.tsx"
    },
    "/installations/": {
      "filePath": "installations/index.tsx"
    },
    "/orders/": {
      "filePath": "orders/index.tsx"
    },
    "/organizations/": {
      "filePath": "organizations/index.tsx"
    },
    "/returns/": {
      "filePath": "returns/index.tsx"
    },
    "/stalled/": {
      "filePath": "stalled/index.tsx"
    },
    "/stations/": {
      "filePath": "stations/index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
